import React from 'react';

const Favicon = () => {
  return (
    <link rel="icon" href="/favicon.ico" />
  );
};

export default Favicon;
